import { trackMixPanel } from './mixpanel.service';

interface IFirstImpressionAnalyticsProps {
  customerProfilePLan: string;
  value: string;
}

export const FirstImpressionReportStartAnimation = ({ customerProfilePLan, value }: IFirstImpressionAnalyticsProps) => {
  trackMixPanel('View first impression widget ', {
    value,
    plan: customerProfilePLan,
  });
};

export const FirstImpressionReportClickCtaAfterAnimation = ({
  customerProfilePLan,
  value,
}: IFirstImpressionAnalyticsProps) => {
  trackMixPanel('Act on first impression widget', {
    value,
    plan: customerProfilePLan,
  });
};
